import React, { useContext } from 'react';
import { SelectValueViewer } from 'components';
import CompGroupContext from 'context/CompGroupContext';
import { getSelectionCellOptions } from 'pages/ValuationsAllocation/util/getSelectionCellOptions';

type MultipleTypeValueViewerProps = {
  shouldIgnorePercentiles: boolean;
  shouldIgnoreSpecified: boolean;
  [key: string]: any;
};

const MultipleTypeValueViewer = ({
  shouldIgnorePercentiles,
  shouldIgnoreSpecified,
  ...props
}: MultipleTypeValueViewerProps) => {
  const { cellOptions } = useContext(CompGroupContext);
  const cellOptionsData = cellOptions || props.performanceCellOptions;

  const options = getSelectionCellOptions({
    specificApproach: cellOptionsData,
    shouldIgnorePercentiles,
    shouldIgnoreSpecified,
  });

  return <SelectValueViewer options={options} useLabel {...props} />;
};

export default MultipleTypeValueViewer;
